// src/utils/haptics.js
export function canVibrate() {
  try {
    return typeof window !== "undefined" && "vibrate" in navigator;
  } catch {
    return false;
  }
}

export function lightTap(pattern = 10) {
  try {
    if (canVibrate()) {
      // Single short pulse; pattern can be [10, 20, 10] etc later
      return navigator.vibrate(pattern);
    }
  } catch {
    // fail silently on platforms that don't like it
  }
  return false;
}
